export type MemberPanelCardLink = {
  cardLinkLabel: string;
  cardLinkPath: string;
  cardLinkId?: string;
};

export const MEMBERPANEL_CONSTANTS = {
  MY_TRIPS: 'myTrips',
  BENEFITS: 'benefits',
  MEMBER_BENEFITS_LINK: 'https://www.marriott.com/loyalty/member-benefits/',
};
